import styled from 'styled-components'

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  width: 100%;
  min-height: 50px;
`

export const Text = styled.p`
  color: ${props => props.theme.colors.secondary};
`



// WEBPACK FOOTER //
// ./src/components/LoadingOrErrorCollection/theme.js